import React, { useEffect, useState } from 'react';
import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { MdOutlineArrowForward } from 'react-icons/md';
import loadingGif from '../assets/images/loading.gif';

const settings = {
  lazyload: true,
  controls: true,
  mouseDrag: true,
  loop: true,
  rewind: true,
  autoplay: true,
  autoplayButtonOutput: false,
  autoplayTimeout: 3000,
  navPosition: "bottom",
  controlsText: [
    '<i class="mdi mdi-chevron-left"></i>',
    '<i class="mdi mdi-chevron-right"></i>'
  ],
  nav: false,
  speed: 400,
  gutter: 0,
  responsive: {
    1025: {
      items: 4
    },
    992: {
      items: 3
    },
    767: {
      items: 2
    },
    320: {
      items: 1
    },
  },
};

export default function Collections() {
  const [nfts, setNfts] = useState([]);
  const [owners, setOwners] = useState({});
  const [loading, setLoading] = useState(true); // Добавляем состояние для отображения загрузки

  // Функция перемешивания массива (алгоритм Фишера–Йетса)
  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  useEffect(() => {
    const fetchNFTs = async () => {
      try {
        // Получаем данные NFT
        const nftResponse = await axios.get('https://nifty-art.com/api/nfts/market', {
          params: { page: 1, limit: 200 }
        });
        // Правильно обрабатываем новый формат API с пагинацией
        let nftData = [];
        if (nftResponse.data.nfts && Array.isArray(nftResponse.data.nfts)) {
          nftData = nftResponse.data.nfts;
        } else if (Array.isArray(nftResponse.data)) {
          nftData = nftResponse.data;
        } else {
          console.error('Unexpected API response format:', nftResponse.data);
          nftData = [];
        }
  
        // Показываем NFT без рандомизации
        const shuffledNFTs = nftData; // Убираем shuffleArray чтобы показать все
  
        // Создаём карту владельцев из полученных данных
        const ownerDataMap = {};
        shuffledNFTs.forEach(nft => {
          if (nft.ownerUsername) {
            ownerDataMap[nft.owner] = {
              ownerId: nft.owner,
              username: nft.ownerUsername,
              firstName: nft.ownerFirstName || nft.ownerData?.firstName || '',
              lastName: nft.ownerLastName || nft.ownerData?.lastName || '',
              avatar: nft.ownerAvatar || '/assets/images/avatar/2.jpg'
            };
          }
        });
  
        setNfts(shuffledNFTs);
        setOwners(ownerDataMap);
  
        // Убираем предзагрузку изображений - используем ленивую загрузку
      } catch (error) {
        console.error('Error fetching NFTs:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchNFTs();
  }, []);
  
  

  return (
    <div className="container md:mt-36 mt-24">
      <div className="md:flex justify-between items-center">
        <div className="md:w-10/12 md:text-start text-center">
          <h3 className="md:text-[30px] text-[26px] font-semibold">Top Items</h3>
        </div>
        <div className="md:w-2/12 text-end md:block hidden">
          <Link to="/explore-one" className="btn btn-link text-[16px] font-medium hover:text-violet-600 after:bg-violet-600 duration-500 ease-in-out inline-flex items-center">
            See More <MdOutlineArrowForward className="text-sm ms-1" />
          </Link>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center mt-10">
          <img src={loadingGif} alt="Loading..." />
        </div>
      ) : (
        <div className="grid relative grid-cols-1 mt-10">
          <div className="tiny-four-icon-item">
            <TinySlider settings={settings}>
              {
                nfts.map((nft, index) => {
                  const owner = owners[nft.owner];
                  return (
                    <div className="tiny-slide" key={index}>
                      <div className="group relative overflow-hidden bg-white dark:bg-slate-900 rounded-lg p-3 shadow dark:shadow-gray-800 ease-in-out duration-500 m-2">
                        <img
                          src={
                            nft.image.startsWith('/uploads/nfts/')
                              ? `https://nifty-art.com${nft.image}`
                              : nft.image
                          }
                          className="rounded-lg shadow-md dark:shadow-gray-700 group-hover:scale-110 transition-all duration-500"
                          alt={nft.name}
                        />

                        <div className="relative p-4 -mt-14">
                          <div className="relative inline-block">
                            <img
                              src={owner?.avatar || '/assets/images/avatar/2.jpg'}
                              className="h-16 rounded-md shadow-md dark:shadow-gray-800"
                              alt={owner?.username}
                            />
                            <i className="mdi mdi-check-decagram text-emerald-600 text-2xl absolute -bottom-3 -end-2"></i>
                          </div>
                          <div className="my-3">
                            <Link to={`/item-detail/${owner?.username}/${nft.contract}/${nft.identifier}`} className="font-semibold hover:text-violet-600">
                              {nft.name}
                            </Link>
                          </div>
                          <div className="mt-3">
                            <Link to={`/item-detail/${owner?.username}/${nft.contract}/${nft.identifier}`} className="font-semibold block text-[18px] hover:text-violet-600">
                              {nft.title}
                            </Link>
                            <span className="text-slate-400 mt-1 text-sm">
                              <span className="italic">by</span> <Link to={`/creator-profile/${owner?.username || 'Unknown'}`} className="text-violet-600 font-medium">
                                {owner?.username || 'Unknown'}
                              </Link>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </TinySlider>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 mt-6 md:hidden">
        <div className="text-center">
          <Link to="/explore-one" className="btn btn-link text-[16px] font-medium hover:text-violet-600 after:bg-violet-600 duration-500 ease-in-out inline-flex items-center">
            See More <MdOutlineArrowForward className="text-sm ms-1" />
          </Link>
        </div>
      </div>
    </div>
  );
}

